import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const STEPS = ["Digital AI", "Interactive AI", "Humanoid AI"];

export default function FutureVision() {
  return (
    <section data-testid="future-vision-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-[1.2fr_1fr] lg:px-10">
        <div>
          <Reveal>
            <SectionTag>Future Vision</SectionTag>
            <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
              From Digital AI Characters to <span className="text-cyan-300">Physical AI</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#C5CBD5]">
              Our long-term ambition is to bring the same AI characters and intelligence beyond the
              screen — and, ultimately, into humanoid robots. The focus today remains firmly on the
              digital experience: real-time video, voice and conversation. Robotics is the future
              vision, not the current product.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div data-testid="vision-progression" className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-3">
              {STEPS.map((step, i) => (
                <div key={step} className="flex items-center gap-4">
                  <span
                    className={`rounded-full border px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.18em] ${
                      i === STEPS.length - 1
                        ? "border-cyan-300/40 bg-cyan-300/10 text-cyan-200"
                        : "border-white/15 text-[#C5CBD5]"
                    }`}
                  >
                    {step}
                  </span>
                  {i < STEPS.length - 1 && <ArrowRight size={14} className="text-white/25" />}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <a
              href="/roadmap/humanoid-ai"
              data-testid="vision-explore-link"
              className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold text-cyan-300/90 transition-colors duration-300 hover:text-cyan-100"
            >
              Explore the long-term vision
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative mx-auto w-full max-w-lg">
            <div className="pointer-events-none absolute -inset-6 rounded-[28px] bg-cyan-400/5 blur-2xl" />
            <div className="relative overflow-hidden rounded-2xl border border-white/10">
              <img
                src="/assets/humanoid.jpg"
                alt="Humanoid AI robot facing a digital display showing a photorealistic AI character — long-term vision, concept visual"
                className="aspect-[4/3] w-full object-cover object-center opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <p className="absolute inset-x-0 bottom-0 p-5 text-[10px] uppercase tracking-[0.22em] text-white/70">
                Long-term vision — robotics remains secondary
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
